import axios from "axios"
import { config } from "../../config"
import store from "../../redux/store"

const request_otp_code_for_admin_action = (userId) => {
    return new Promise((resolve, reject) => {

        axios.get(`${config.ERISED_BACKEND_URL}/users/adminOTP`)
        .then(res => {
            resolve(res)
        })
        .catch(() => {
            resolve(false);
        })
    })
}

const delete_user_preview = (username) => {
    return new Promise((resolve, reject) => {

        axios.post(`${config.ERISED_BACKEND_URL}/admins/deleteUserPreview`, {username: username})
        .then(res => {
            resolve(res)
        })
        .catch(() => {
            resolve(false);
        })
    })
}

const actually_delete_user = (username, otp) => {
    return new Promise((resolve, reject) => {

        axios.post(`${config.ERISED_BACKEND_URL}/admins/actuallyDeleteUser`, {username: username, otp: otp})
        .then(res => {
            console.error('deletion', res);
            resolve(res)
        })
        .catch(() => {
            resolve(false);
        })
    })
}


export {
    request_otp_code_for_admin_action,
    delete_user_preview,
    actually_delete_user
};
